import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { IntegrationLogReportschemaObject } from "../IntegrationLogReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _ from 'lodash';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';

const screenCode = "INTEGRATIONLOGREPORT";

export function IntegrationLogReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [field, setField] = useState([]);
    const [block, setBlock] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [integrationLogReport, setIntegrationLogReport] = useState({
        groupID: "0",
        estateID: "0",
        date: "",
        divisionID: "0",
        fieldID: "0",
        attendanceTypeID: "0",
        blockID: "0",
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        field: "",
        date: "",
        attendanceType: "0",
        block: "0"
    })
    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);
    const schema = Joi.object(IntegrationLogReportschemaObject).options({ allowUnknown: true });
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [sundryReportData, setSundryReportData] = useState([]);
    const [pluckingReportData, setPluckingReportData] = useState([]);
    const [keys, setKeys] = useState([]);
    const [totalValues, setTotalValues] = useState({
        totalRSMQuantity: 0,
        totalPluckingQuantity: 0
    });
    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown()
        )
    }, [integrationLogReport.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
        )
    }, [integrationLogReport.estateID])

    useEffect(() => {
        trackPromise(getFieldForDropdown())
    }, [integrationLogReport.divisionID]);

    useEffect(() => {
        trackPromise(getBlocksForDropdown())
    }, [integrationLogReport.fieldID]);

    useEffect(() => {
        setIntegrationLogReport({
            ...integrationLogReport,
            blockID: "0"

        });
    }, [integrationLogReport.attendanceTypeID]);

    useEffect(() => {
        clearTable()
    }, [integrationLogReport]);

    useEffect(() => {
    }, [reportData]);

    useEffect(() => {
        if (reportData.length != 0) {
            calculateTotal()
        }
    }, [reportData]);

    useEffect(() => {
        if (sundryReportData.length != 0) {
            calculateTotal()
        }
    }, [sundryReportData]);

    useEffect(() => {
        if (pluckingReportData.length != 0) {
            calculateTotal()
        }
    }, [pluckingReportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setIntegrationLogReport({
            ...integrationLogReport,
            groupID: target.value,
            estateID: "0",
            divisionID: "0"

        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setIntegrationLogReport({
            ...integrationLogReport,
            estateID: target.value,
            divisionID: "0"

        });
    }

    function handleDivisionChange(target) {
        setIntegrationLogReport({
            ...integrationLogReport,
            divisionID: target.value

        });
    }


    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, IntegrationLogReportschemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWINTEGRATIONLOGREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromToken();

        setIntegrationLogReport({
            ...integrationLogReport,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(integrationLogReport.groupID);
        setEstates(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(integrationLogReport.estateID);
        setDivisions(data);
    }

    async function getFieldForDropdown() {
        const data = await services.GetFieldsByCollectionPoint(integrationLogReport.divisionID);
        setField(data);
    }

    async function getBlocksForDropdown() {
        const data = await services.GetBlocksByFieldID(integrationLogReport.fieldID);
        setBlock(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function handleChange(e) {
        const target = e.target;

        const value = target.type === "checkbox" ? target.checked : target.value;
        setIntegrationLogReport({
            ...integrationLogReport,
            [e.target.name]: value,
        });
    }

    async function handleSearch(e) {

        getSelectedDropdownValuesForReport(integrationLogReport);

        setIsTableHide(true);

        if (integrationLogReport.attendanceTypeID === "3") {

            const result = await services.getIntegrationLogRSMReportDetails(integrationLogReport);
            setReportData(result)

            setKeys(keys);
            setReportData(result);


            if (result.length > 0) {
                setIsTableHide(false);
                setIsReportButtonsEnabled(true);
            } else {
                setIsReportButtonsEnabled(false);
            }


            setButtonHide(false);
            setIsReportButtonsEnabled();

            const comlpeteData = [...result];
            setCsvData(comlpeteData)
        } else {

            const result = await services.getIntegrationLogReportDetails(integrationLogReport);
            setReportData(result)

            const pluckingData = [];
            const sundryData = [];
            result.forEach(results => {
                if (results.attendenceType === "1") {
                    pluckingData.push(results);
                } else if (results.attendenceType === "0") {
                    sundryData.push(results);
                }
            });

            setPluckingReportData(pluckingData);
            setSundryReportData(sundryData);
            setKeys(keys);
            setReportData(result);

            if (result.length > 0) {
                setIsTableHide(false);
                setIsReportButtonsEnabled(true);
            } else {
                setIsReportButtonsEnabled(false);
            }


            setButtonHide(false);
            setIsReportButtonsEnabled();

            const comlpeteData = [...result];
            setCsvData(comlpeteData)
        }
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setIntegrationLogReport({
            ...integrationLogReport,
            date: target.value
        });
        clearTable();
    }

    function handleChangeCommon(target) {
        validateInputs(target);

        setIntegrationLogReport({
            ...integrationLogReport,
            [target.name]: target.value
        });
        clearTable();
    }

    function calculateTotal() {

        const totalRSMQuantity = reportData.reduce((accumulator, current) => {
            const progressFraction = current.quantity;
            return accumulator + progressFraction;
        }, 0);

        const totalPluckingQuantity = pluckingReportData.reduce((accumulator, current) => {
            const progressFraction = current.quantity;
            return accumulator + progressFraction;
        }, 0);

        setTotalValues({
            ...totalValues,
            totalRSMQuantity: totalRSMQuantity,
            totalPluckingQuantity: totalPluckingQuantity
        });
    }

    async function createDataForExcel(array) {
        let res = [];
        if (array != null) {
            if (integrationLogReport.attendanceTypeID === "3") {
                array.forEach(x => {
                    const vr = {
                        'Date': new Date(x.attendanceDate).toLocaleDateString('en-CA'),
                        'Division': x.division,
                        'Field': x.field,
                        'Block': x.block,
                        'Employee No': x.employeeID,
                        'Employee Name': x.employeeName,
                        'Integration Status': (x.isSentToNavition == true || "Yes" ? 'Yes' : 'No'),
                        'Quantity (Kg)': x.quantity,
                    };
                    res.push(vr);
                });

                const total = totalValues.totalRSMQuantity;

                res.push({
                    'Date': 'Total',
                    'Quantity (Kg)': total,
                });
                res.push([]);

                res.push({
                    'Date': 'Group : ' + selectedSearchValues.group,
                    'Division': 'Estate : ' + selectedSearchValues.estate,
                    'Field': 'Division : ' + (selectedSearchValues.division === undefined ? "All Divisions" : selectedSearchValues.division),
                    'Block': 'Field : ' + (selectedSearchValues.field === undefined ? "All Fields" : selectedSearchValues.field),
                    'Employee No': '' + (selectedSearchValues.attendanceType == 1 ? 'Attendance Type : Plucking' : selectedSearchValues.attendanceType == 2 ? 'Attendance Type : Sundry' : 'Attendance Type : RSM'),
                    'Employee Name': 'Block : ' + (selectedSearchValues.block === undefined ? "All Blocks" : selectedSearchValues.block),
                    'Integration Status': 'Date : ' + selectedSearchValues.date,
                });
            } else if (integrationLogReport.attendanceTypeID === "2") {
                array.forEach(x => {
                    const vr = {
                        'Date': new Date(x.attendanceDate).toLocaleDateString('en-CA'),
                        'Division': x.division,
                        'Field': x.field,
                        'Job': x.job,
                        'Employee No': x.employeeID,
                        'Employee Name': x.employeeName,
                        'Integration Status': (x.isSentToNavition == true ? 'Yes' : 'No'),
                    };
                    res.push(vr);
                });

                res.push({
                    'Date': 'Group : ' + selectedSearchValues.group,
                    'Division': 'Estate : ' + selectedSearchValues.estate,
                    'Field': 'Division : ' + (selectedSearchValues.division === undefined ? "All Divisions" : selectedSearchValues.division),
                    'Job': 'Field : ' + (selectedSearchValues.field === undefined ? "All Fields" : selectedSearchValues.field),
                    'Employee No': '' + (selectedSearchValues.attendanceType == 1 ? 'Attendance Type : Plucking' : selectedSearchValues.attendanceType == 2 ? 'Attendance Type : Sundry' : 'Attendance Type : RSM'),
                    'Employee Name': 'Date : ' + selectedSearchValues.date,
                });
            } else if (integrationLogReport.attendanceTypeID === "1") {
                array.forEach(x => {
                    const vr = {
                        'Date': new Date(x.attendanceDate).toLocaleDateString('en-CA'),
                        'Division': x.division,
                        'Field': x.field,
                        'Job': x.job,
                        'Employee No': x.employeeID,
                        'Employee Name': x.employeeName,
                        'Integration Status': (x.isSentToNavition == true ? 'Yes' : 'No'),
                        'Cash': (x.cashWork == true ? 'Yes' : 'No'),
                        'Quantity (Kg)': x.quantity,
                    };
                    res.push(vr);
                });

                const total = totalValues.totalPluckingQuantity;

                res.push({
                    'Date': 'Total',
                    'Quantity (Kg)': total,
                });
                res.push([]);

                res.push({
                    'Date': 'Group : ' + selectedSearchValues.group,
                    'Division': 'Estate : ' + selectedSearchValues.estate,
                    'Field': 'Division : ' + (selectedSearchValues.division === undefined ? "All Divisions" : selectedSearchValues.division),
                    'Job': 'Field : ' + (selectedSearchValues.field === undefined ? "All Fields" : selectedSearchValues.field),
                    'Employee No': '' + (selectedSearchValues.attendanceType == 1 ? 'Attendance Type : Plucking' : selectedSearchValues.attendanceType == 2 ? 'Attendance Type : Sundry' : 'Attendance Type : RSM'),
                    'Employee Name': 'Date : ' + selectedSearchValues.date,
                });
            }
        }
        return res;
    }

    async function createFile() {
        let file;
        if (integrationLogReport.attendanceTypeID === "3") {
            file = await createDataForExcel(reportData);
        } else if (integrationLogReport.attendanceTypeID === "2") {
            file = await createDataForExcel(sundryReportData);
        } else if (integrationLogReport.attendanceTypeID === "1") {
            file = await createDataForExcel(pluckingReportData);
        }

        const settings = {
            sheetName: 'Integration Log Report',
            fileName: 'Integration Log Report',
            writeOptions: {}
        };

        let keys = Object.keys(file[0]);
        let tempcsvHeaders = [...csvHeaders];
        keys.forEach((sitem) => {
            tempcsvHeaders.push({ label: sitem, value: sitem });
        });

        xlsx(tempcsvHeaders, file, settings, true);
    }

    function getSelectedDropdownValuesForReport() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[integrationLogReport.groupID],
            estate: estates[integrationLogReport.estateID],
            division: divisions[integrationLogReport.divisionID],
            field: field[integrationLogReport.fieldID],
            attendanceType: integrationLogReport.attendanceTypeID,
            date: integrationLogReport.date,
            block: block[integrationLogReport.blockID]
        })
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setIntegrationLogReport({
            ...integrationLogReport,
            date: "",
            divisionID: "0",
            fieldID: "0",
            attendanceTypeID: "0",
            blockID: "0",
        });
        setIsTableHide(true);
        setErrors("");
    }


    function clearTable() {
        setIsTableHide(true);
        setReportData([]);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Integration Log Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form onSubmit={(e) => handleSearch(e)}>
                                <div className="form-group row">
                                    <div className="col-md-3">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={integrationLogReport.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md-3">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={integrationLogReport.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (
                                            <FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md-3">
                                        <InputLabel shrink id="divisionID">Division </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={integrationLogReport.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--All Divisions--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (
                                            <FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md-3">
                                        <InputLabel shrink id="fieldID">Field</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="fieldID"
                                            id="fieldID"
                                            name="fieldID"
                                            value={integrationLogReport.fieldID}
                                            onChange={(e) => handleChangeCommon(e.target)}
                                        >
                                            <MenuItem value="0">--All Fields--</MenuItem>
                                            {generateDropDownMenu(field)}
                                        </Select>
                                        {errors["fieldID"] && (
                                            <FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldID"]}</FormHelperText>
                                        )}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-3">
                                        <InputLabel shrink id="attendanceTypeID">Attendance Type *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="attendanceTypeID"
                                            id="attendanceTypeID"
                                            name="attendanceTypeID"
                                            value={integrationLogReport.attendanceTypeID}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="0">--Select Attendance Type--</MenuItem>
                                            <MenuItem value="1">Plucking</MenuItem>
                                            <MenuItem value="2">Sundry</MenuItem>
                                            <MenuItem value="3">RSM</MenuItem>
                                        </Select>
                                        {errors["attendanceTypeID"] && (
                                            <FormHelperText id="errAttendanceTypeID" className="text text-danger">
                                                {errors["attendanceTypeID"]}
                                            </FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md-3">
                                        <InputLabel shrink id="blockID">Block</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="blockID"
                                            id="blockID"
                                            name="blockID"
                                            value={integrationLogReport.blockID}
                                            onChange={(e) => handleChangeCommon(e.target)}
                                            disabled={integrationLogReport.attendanceTypeID !== "3"}
                                            style={{
                                                backgroundColor: integrationLogReport.attendanceTypeID !== "3" ? '#e9ecef' : 'inherit',
                                                color: integrationLogReport.attendanceTypeID !== "3" ? '#6c757d' : 'inherit',
                                                pointerEvents: integrationLogReport.attendanceTypeID !== "3" ? 'none' : 'auto'
                                            }}
                                        >
                                            <MenuItem value="0">--All Blocks--</MenuItem>
                                            {generateDropDownMenu(block)}
                                        </Select>
                                        {errors["blockID"] && (
                                            <FormHelperText id="errbranchCode" className="text text-danger">{errors["blockID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md-3">
                                        <InputLabel shrink id="date">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            value={integrationLogReport.date}
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["date"] && (
                                            <FormHelperText id="errbranchCode" className="text text-danger">{errors["date"]}</FormHelperText>
                                        )}
                                    </div><div className="col-md-3 d-flex align-items-end justify-content-end mt-3">
                                        <input
                                            disabled={validate(schema, integrationLogReport)}
                                            type="button"
                                            className="btn btn-primary"
                                            value="Search"
                                            onClick={e => trackPromise(handleSearch(e))}
                                        />
                                        <input
                                            type="reset"
                                            className="btn btn-warning ml-2"
                                            value="Cancel"
                                            onClick={onCancelClick}
                                        />
                                    </div>
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="col-md-12 pt-2 pb-3">
                                            <div className="card p-2">
                                                <div className="table-responsive row-top-gap">
                                                    <Box display="flex" justifyContent="flex-end" p={2}>
                                                        {integrationLogReport.attendanceTypeID === "3" ?
                                                            <TableContainer component={Paper} style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                                                <Table aria-label="sticky table" Table stickyHeader>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Date
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Division
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Field
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Block
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Employee No
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Employee Name
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Integration Status
                                                                            </TableCell>
                                                                            <TableCell align="right" style={{ fontWeight: "bold" }}>
                                                                                Quantity (Kg)
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {reportData.map((row) => (
                                                                            <TableRow key={row.employeeCode}>
                                                                                <TableCell component="th" scope="row">
                                                                                    {new Date(row.attendanceDate).toLocaleDateString('en-CA')}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.division}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.field}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.block}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.employeeID}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.employeeName}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.isSentToNavition == true ? 'Yes' : 'No'}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row" align="right">
                                                                                    {row.quantity}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                    <TableBody>
                                                                        <TableRow>
                                                                            <TableCell colSpan={7} align="left" style={{ fontWeight: "bold" }}>Total</TableCell>
                                                                            <TableCell component="th" scope="row" align="right">{totalValues.totalRSMQuantity}</TableCell>
                                                                        </TableRow>
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer> : null}
                                                        {integrationLogReport.attendanceTypeID === "2" ?
                                                            <TableContainer component={Paper} style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                                                <Table aria-label="sticky table" Table stickyHeader>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Date
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Division
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Field
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Job
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Employee No
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Employee Name
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Integration Status
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {sundryReportData.map((row) => (
                                                                            <TableRow key={row.employeeCode}>
                                                                                <TableCell component="th" scope="row">
                                                                                    {new Date(row.attendanceDate).toLocaleDateString('en-CA')}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.division}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.field}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.job}
                                                                                </TableCell><TableCell component="th" scope="row">
                                                                                    {row.employeeID}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.employeeName}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.isSentToNavition == true ? 'Yes' : 'No'}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer> : null}
                                                        {integrationLogReport.attendanceTypeID === "1" ?
                                                            <TableContainer component={Paper} style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                                                <Table aria-label="sticky table" Table stickyHeader>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Date
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Division
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Field
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Job
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Employee No
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Employee Name
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Integration Status
                                                                            </TableCell>
                                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                                                Cash
                                                                            </TableCell>
                                                                            <TableCell align="right" style={{ fontWeight: "bold" }}>
                                                                                Quantity
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {pluckingReportData.map((row) => (
                                                                            <TableRow key={row.employeeCode}>
                                                                                <TableCell component="th" scope="row">
                                                                                    {new Date(row.attendanceDate).toLocaleDateString('en-CA')}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.division}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.field}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.job}
                                                                                </TableCell><TableCell component="th" scope="row">
                                                                                    {row.employeeID}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.employeeName}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row">
                                                                                    {row.isSentToNavition == true ? 'Yes' : 'No'}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row" align="right">
                                                                                    {row.cashWork == true ? 'Yes' : 'No'}
                                                                                </TableCell>
                                                                                <TableCell component="th" scope="row" align="right">
                                                                                    {row.quantity}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                    <TableBody>
                                                                        <TableRow>
                                                                            <TableCell colSpan={8} align="left" style={{ fontWeight: "bold" }}>Total</TableCell>
                                                                            <TableCell component="th" scope="row" align="right">{totalValues.totalPluckingQuantity}</TableCell>
                                                                        </TableRow>
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>
                                                            : null}
                                                    </Box>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Daily Block Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf
                                            ref={componentRef} reportData={reportData}
                                            pluckingReportData={pluckingReportData}
                                            sundryReportData={sundryReportData}
                                            integrationLogReport={integrationLogReport.attendanceTypeID}
                                            searchData={selectedSearchValues}
                                            totalValues={totalValues}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
